import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@sm360/ui-library';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, VIRTUAL_PAGEVIEWS as PAGES, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import ActionButton from 'trade-in-360/components/InstantEstimateWrapper/Components/ActionButton/ActionButton.jsx';
import WEB_CSS_CLASSNAMES from 'trade-in-360/constants/webCssClassnames.js';
import './ConfirmationModal.scss';

const ConfirmationModal = ({
    isOpen,
    onCancel,
    onConfirm,
    cancelLabel,
    confirmLabel,
    title,
    description,
    classNames,
    isMainCTA,
    isSingleVehicleConfirmation,
}) => {
    React.useEffect(
        () => {
            if (isOpen) {
                if (isSingleVehicleConfirmation) {
                    AnalyticsService.virtualPageView(PAGES.TRADE_IN_ONE_ASSOCIATED_VEHICLE_CONFIRMATION());
                }
            }
        },
        [isOpen]
    );

    const handleConfirm = () => {
        AnalyticsService.ga4Trigger(TAGS.TRADE_IN_CONFIRM_BTN());
        onConfirm();
    };

    const handleCancel = () => {
        AnalyticsService.ga4Trigger(TAGS.TRADE_IN_CANCEL_BTN());
        onCancel();
    };

    return (
        <Modal isModalOpen={isOpen} modalScopeCSS="crm" className={`trade-360 confirm-modal ${classNames}`}>
            {() => (
                <>
                    <div id="Wizard--body">
                        <div className={WEB_CSS_CLASSNAMES.HEADING3}>
                            {title || LocaleService.t('TRADE_IN.CONFIRMATION_MODAL.TITLE')}
                        </div>
                        <div className={WEB_CSS_CLASSNAMES.BODY1}>
                            {description || LocaleService.t('TRADE_IN.CONFIRMATION_MODAL.DESCRIPTION')}
                        </div>
                        <div className="vehicle-buttons-container">
                            <button
                                type="button"
                                className="uk-button uk-button--close"
                                id="close-modal-button-confirmation"
                                onClick={handleCancel}
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <div className="vehicle-buttons">
                                <ActionButton
                                    next={isMainCTA}
                                    noPrefix
                                    noArrow
                                    noSubmit
                                    onClick={handleConfirm}
                                    isMainCTA={isMainCTA}
                                >
                                    {confirmLabel || LocaleService.t('TRADE_IN.BUTTONS.QUIT')}
                                </ActionButton>
                                <ActionButton next={!isMainCTA} noPrefix noArrow noSubmit onClick={handleCancel}>
                                    {cancelLabel || LocaleService.t('TRADE_IN.BUTTONS.CANCEL')}
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </Modal>
    );
};

ConfirmationModal.defaultProps = {
    isOpen: false,
    cancelLabel: '',
    confirmLabel: '',
    title: '',
    description: '',
    classNames: '',
    isMainCTA: false,
    isSingleVehicleConfirmation: false,
};

ConfirmationModal.propTypes = {
    /* Controlled value for opening status of the modal */
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    cancelLabel: PropTypes.string,
    confirmLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    classNames: PropTypes.string,
    isMainCTA: PropTypes.bool,
    isSingleVehicleConfirmation: PropTypes.bool,
};

ConfirmationModal.displayName = 'ConfirmationModal';
export default ConfirmationModal;
